<template>
  <li class="nav-item">
    <a :href="href" class="nav-link">{{ title }}</a>
  </li>
</template>

<script>
export default {
  props: {
    title: String,
    href: String
  }
};
</script>

<style>
</style>
